/**
 * Calls of the account activation / forgotten password flow. Anonymous by
 * nature: plain fetch, without the patron token a stale session could hold.
 */

const API = "/api/portal/account-access";

export interface LinkInfo {
  /** First activation (no password yet) rather than a forgotten password */
  activation: boolean;
  firstName: string;
}

export class AccountAccessError extends Error {
  constructor(
    message: string,
    readonly status: number
  ) {
    super(message);
  }
}

async function post<T>(path: string, body: Record<string, string>): Promise<T> {
  let response: Response;
  try {
    response = await fetch(`${API}${path}`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    });
  } catch {
    throw new AccountAccessError("Le serveur est injoignable. Vérifiez votre connexion.", 0);
  }

  const data = (await response.json().catch(() => ({}))) as T & { error?: string };
  if (!response.ok) {
    throw new AccountAccessError(
      data.error ?? "Une erreur est survenue. Réessayez plus tard.",
      response.status
    );
  }

  return data;
}

export function requestLink(identifier: string): Promise<{ message: string }> {
  return post("/request", { identifier });
}

export function inspectLink(token: string): Promise<LinkInfo> {
  return post("/inspect", { token });
}

export function choosePassword(token: string, password: string): Promise<{ message: string }> {
  return post("/password", { token, password });
}

export const MIN_PASSWORD_LENGTH = 12;
export const MAX_PASSWORD_LENGTH = 128;
